import { useState, useEffect, useMemo, Fragment } from "react";
import { useApp } from "../context/AppContext";

export default function SiteScanView() {
  const { proj, activeId, getStore, setStore, dataRef, projects, setProjects, apiFetch,
    saveClusters, saveContent, saveStructure, saveSemClusters, saveLinks,
    flash, setView, view, dark, setDark, t, card, inp, btnP, btnG, btnSm, stitle, muted, th, td,
    userRole, currentUser, loadProjectData, openP, infoId, setInfoId, setActiveId,
    bgTasks } = useApp();
  if (!proj) return null;
  const store = getStore(activeId);
  const clusters = store.clusters || [];

  const [tab, setTab] = useState("pages");
  const [pages, setPages] = useState([]);
  const [keywords, setKeywords] = useState([]);
  const [search, setSearch] = useState("");
  const [expandedUrl, setExpandedUrl] = useState(null);
  const [expandedKw, setExpandedKw] = useState(null);
  const [loadingKw, setLoadingKw] = useState(false);
  const [visiblePages, setVisiblePages] = useState(50);
  const [visibleKw, setVisibleKw] = useState(100);
  const [extScans, setExtScans] = useState([]);
  const [extSort, setExtSort] = useState("scanned_at");
  const [extSortDir, setExtSortDir] = useState(-1);
  const [visibleExt, setVisibleExt] = useState(50);

  // Load saved pages on mount
  useEffect(() => {
    apiFetch(`/api/projects/${activeId}/site-scan`)
      .then(r => r.json())
      .then(d => { if (Array.isArray(d)) setPages(d); })
      .catch(() => {});
  }, [activeId]);

  // Auto-reload when scan task completes
  useEffect(() => {
    const doneTask = bgTasks.find(bt => bt.projectId === activeId && bt.type === "site_scan" && bt.status === "done");
    if (doneTask) {
      apiFetch(`/api/projects/${activeId}/site-scan`)
        .then(r => r.json())
        .then(d => { if (Array.isArray(d)) setPages(d); })
        .catch(() => {});
    }
  }, [bgTasks, activeId]);

  // Track running scan task
  const activeTask = bgTasks.find(bt => bt.projectId === activeId && bt.type === "site_scan" && bt.status === "running");
  const taskProgress = activeTask?.progress || {};

  const startScan = async () => {
    try {
      await apiFetch(`/api/projects/${activeId}/site-scan`, { method: "POST" });
    } catch (err) {
      console.error("Start scan error:", err);
    }
  };

  const loadKeywords = async () => {
    setLoadingKw(true);
    try {
      const r = await apiFetch(`/api/projects/${activeId}/site-scan/keywords`);
      const d = await r.json();
      if (Array.isArray(d)) setKeywords(d);
    } catch (err) {
      console.error("Load keywords error:", err);
    }
    setLoadingKw(false);
  };

  // Load keywords when switching to that tab
  useEffect(() => {
    if (tab === "keywords" && pages.length > 0 && keywords.length === 0) {
      loadKeywords();
    }
    if (tab === "extension" && extScans.length === 0) {
      apiFetch(`/api/extension/scans/${activeId}`).then(r => r.json()).then(d => { if (Array.isArray(d)) setExtScans(d); }).catch(() => {});
    }
  }, [tab, pages.length]);

  const filteredPages = pages.filter(p =>
    !search || p.url.toLowerCase().includes(search.toLowerCase())
  );

  const filteredKeywords = keywords.filter(k =>
    !search || k.keyword.toLowerCase().includes(search.toLowerCase())
  );

  const checkMark = (val) => val
    ? <span style={{ color: "#16a34a", fontWeight: 700 }}>✓</span>
    : <span style={{ color: "#ccc" }}>✗</span>;

  const tabBtn = (key, label) => (
    <button
      onClick={() => { setTab(key); setSearch(""); }}
      style={{
        ...btnSm,
        background: tab === key ? "#6366f1" : "transparent",
        color: tab === key ? "#fff" : t.text,
        border: `1px solid ${tab === key ? "#6366f1" : t.border}`,
        fontWeight: tab === key ? 700 : 400,
        padding: "6px 16px",
      }}
    >{label}</button>
  );

  return (
    <div>
      <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 14 }}>
        <h2 style={{ fontSize: 18, fontWeight: 700, margin: 0 }}>🔍 Сканер сайту</h2>
      </div>

      {/* Scan button + progress */}
      <div style={{ ...card, padding: 16, marginBottom: 14 }}>
        <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
          <button style={btnP} onClick={startScan} disabled={!!activeTask}>
            {activeTask ? "Сканування..." : "Сканувати"}
          </button>
          {pages.length > 0 && !activeTask && (
            <span style={{ fontSize: 12, color: "#888" }}>
              Відскановано: {pages.filter(p => p.status === "ok").length} / {pages.length} сторінок
            </span>
          )}
        </div>
        {activeTask && taskProgress.total > 0 && (
          <div style={{ marginTop: 10 }}>
            <div style={{ fontSize: 12, color: "#888", marginBottom: 4 }}>
              {taskProgress.current || 0} / {taskProgress.total} — {taskProgress.url && <span style={{ color: "#6366f1" }}>{taskProgress.url.slice(0, 60)}...</span>}
            </div>
            <div style={{ height: 6, background: dark ? "#333" : "#e5e7eb", borderRadius: 3, overflow: "hidden" }}>
              <div style={{ height: "100%", width: `${((taskProgress.current || 0) / taskProgress.total) * 100}%`, background: "linear-gradient(90deg, #6366f1, #a855f7)", borderRadius: 3, transition: "width .3s" }} />
            </div>
          </div>
        )}
      </div>

      {/* Tabs */}
      <div style={{ display: "flex", gap: 8, marginBottom: 14 }}>
        {tabBtn("pages", `Сторінки (${pages.length})`)}
        {tabBtn("keywords", `Ключі на сайті (${keywords.length})`)}
        {tabBtn("extension", `Аудит Extension (${extScans.length})`)}
      </div>

      {/* Search */}
      <input
        value={search}
        onChange={e => setSearch(e.target.value)}
        placeholder={tab === "pages" ? "Пошук по URL..." : "Пошук по ключу..."}
        style={{ ...card, width: "100%", border: `1px solid ${t.border}`, borderRadius: 8, padding: "8px 12px", fontSize: 13, marginBottom: 14, background: t.bg, color: t.text, outline: "none", boxSizing: "border-box" }}
      />

      {/* Tab: Pages */}
      {tab === "pages" && (
        <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
          {filteredPages.length === 0 && pages.length === 0 && !activeTask && (
            <p style={{ fontSize: 13, color: "#888", textAlign: "center", padding: 20 }}>Натисніть "Сканувати" для початку</p>
          )}
          {filteredPages.slice(0, visiblePages).map((p, i) => (
            <div key={i} style={{ ...card, padding: 0, overflow: "hidden" }}>
              <div
                onClick={() => setExpandedUrl(expandedUrl === p.url ? null : p.url)}
                style={{ padding: "10px 14px", cursor: "pointer", display: "flex", alignItems: "center", gap: 8 }}
              >
                <span style={{ fontSize: 11, color: expandedUrl === p.url ? "#6366f1" : "#888", transition: "transform .2s", transform: expandedUrl === p.url ? "rotate(90deg)" : "none" }}>▶</span>
                <span style={{ fontSize: 12, fontWeight: 500, flex: 1, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{p.url}</span>
                {p.status === "error" && <span style={{ fontSize: 10, color: "#ef4444", background: "#fef2f2", padding: "1px 6px", borderRadius: 6 }}>error</span>}
                {p.status === "ok" && <span style={{ fontSize: 10, color: "#16a34a" }}>{p.text_length} сл.</span>}
              </div>
              {expandedUrl === p.url && (
                <div style={{ padding: "0 14px 12px", borderTop: `1px solid ${t.border}`, fontSize: 12 }}>
                  {p.error && <p style={{ color: "#ef4444", marginTop: 8 }}>Помилка: {p.error}</p>}
                  <div style={{ display: "grid", gridTemplateColumns: "100px 1fr", gap: "6px 10px", marginTop: 8 }}>
                    <span style={{ color: "#888", fontWeight: 600 }}>Title:</span>
                    <span>
                      {p.prev_title && p.prev_title !== p.title && <span style={{ textDecoration: "line-through", color: "#ef4444", opacity: 0.7, marginRight: 6 }}>{p.prev_title}</span>}
                      {p.title || <em style={{ color: "#ccc" }}>—</em>}
                    </span>
                    <span style={{ color: "#888", fontWeight: 600 }}>Description:</span>
                    <span>
                      {p.prev_description && p.prev_description !== p.description && <span style={{ textDecoration: "line-through", color: "#ef4444", opacity: 0.7, marginRight: 6 }}>{p.prev_description}</span>}
                      {p.description || <em style={{ color: "#ccc" }}>—</em>}
                    </span>
                    <span style={{ color: "#888", fontWeight: 600 }}>H1:</span>
                    <span>
                      {p.prev_h1 && p.prev_h1 !== p.h1 && <span style={{ textDecoration: "line-through", color: "#ef4444", opacity: 0.7, marginRight: 6 }}>{p.prev_h1}</span>}
                      {p.h1 || <em style={{ color: "#ccc" }}>—</em>}
                    </span>
                    <span style={{ color: "#888", fontWeight: 600 }}>Довжина:</span>
                    <span>
                      {p.prev_text_length > 0 && p.prev_text_length !== p.text_length && <span style={{ textDecoration: "line-through", color: "#ef4444", opacity: 0.7, marginRight: 6 }}>{p.prev_text_length}</span>}
                      {p.text_length} слів
                    </span>
                  </div>
                  {p.headings && p.headings.length > 0 && (
                    <div style={{ marginTop: 8 }}>
                      <span style={{ color: "#888", fontWeight: 600, fontSize: 11 }}>Підзаголовки:</span>
                      <div style={{ marginTop: 4, display: "flex", flexDirection: "column", gap: 2 }}>
                        {p.headings.map((h, j) => (
                          <span key={j} style={{ fontSize: 11, paddingLeft: h.tag === "h3" ? 16 : 0 }}>
                            <span style={{ color: "#a855f7", fontWeight: 600 }}>{h.tag.toUpperCase()}</span> {h.text}
                          </span>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              )}
            </div>
          ))}
          {filteredPages.length > visiblePages && (
            <button style={{ ...btnSm, width: "100%", marginTop: 8, padding: "8px 0" }} onClick={() => setVisiblePages(v => v + 50)}>
              Показати ще ({filteredPages.length - visiblePages} залишилось)
            </button>
          )}
        </div>
      )}

      {/* Tab: Keywords */}
      {tab === "keywords" && (
        <div>
          {loadingKw && <p style={{ fontSize: 13, color: "#888", textAlign: "center", padding: 20 }}>Завантаження матриці ключів...</p>}
          {!loadingKw && filteredKeywords.length === 0 && (
            <p style={{ fontSize: 13, color: "#888", textAlign: "center", padding: 20 }}>
              {pages.length === 0 ? "Спочатку відскануйте сторінки" : "Ключі не знайдені"}
            </p>
          )}
          {!loadingKw && filteredKeywords.length > 0 && (
            <div style={{ overflowX: "auto" }}>
              <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 12 }}>
                <thead>
                  <tr style={{ borderBottom: `2px solid ${t.border}` }}>
                    <th style={{ textAlign: "left", padding: "8px 10px", fontWeight: 700 }}>Ключ</th>
                    <th style={{ textAlign: "center", padding: "8px 6px", fontWeight: 700 }}>Частота</th>
                    <th style={{ textAlign: "center", padding: "8px 6px", fontWeight: 700 }}>Стор.</th>
                    <th style={{ textAlign: "center", padding: "8px 6px", fontWeight: 700 }}>Title</th>
                    <th style={{ textAlign: "center", padding: "8px 6px", fontWeight: 700 }}>Desc</th>
                    <th style={{ textAlign: "center", padding: "8px 6px", fontWeight: 700 }}>H1</th>
                    <th style={{ textAlign: "center", padding: "8px 6px", fontWeight: 700 }}>H2/H3</th>
                    <th style={{ textAlign: "center", padding: "8px 6px", fontWeight: 700 }}>Текст</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredKeywords.slice(0, visibleKw).map((kw, i) => {
                    const anyTitle = kw.pages.some(p => p.inTitle);
                    const anyDesc = kw.pages.some(p => p.inDesc);
                    const anyH1 = kw.pages.some(p => p.inH1);
                    const anyHeadings = kw.pages.some(p => p.inHeadings);
                    const anyText = kw.pages.some(p => p.inText);
                    const isExpanded = expandedKw === kw.keyword;

                    return (
                      <Fragment key={i}>
                        <tr
                          onClick={() => setExpandedKw(isExpanded ? null : kw.keyword)}
                          style={{ borderBottom: `1px solid ${t.border}`, cursor: "pointer", background: isExpanded ? (dark ? "#1e1e2e" : "#f5f3ff") : "transparent" }}
                        >
                          <td style={{ padding: "8px 10px", fontWeight: 500 }}>
                            <span style={{ color: isExpanded ? "#6366f1" : "#888", fontSize: 10, marginRight: 6, transition: "transform .2s", display: "inline-block", transform: isExpanded ? "rotate(90deg)" : "none" }}>▶</span>
                            {kw.keyword}
                          </td>
                          <td style={{ textAlign: "center", padding: "8px 6px", color: t.textMuted }}>{kw.frequency}</td>
                          <td style={{ textAlign: "center", padding: "8px 6px" }}>
                            <span style={{ background: kw.pages.length > 0 ? "#dbeafe" : (dark ? "#252535" : "#f3f4f6"), color: kw.pages.length > 0 ? "#1e40af" : t.textMuted, padding: "1px 6px", borderRadius: 8, fontSize: 10, fontWeight: 600 }}>{kw.pages.length}</span>
                          </td>
                          <td style={{ textAlign: "center" }}>{checkMark(anyTitle)}</td>
                          <td style={{ textAlign: "center" }}>{checkMark(anyDesc)}</td>
                          <td style={{ textAlign: "center" }}>{checkMark(anyH1)}</td>
                          <td style={{ textAlign: "center" }}>{checkMark(anyHeadings)}</td>
                          <td style={{ textAlign: "center" }}>{checkMark(anyText)}</td>
                        </tr>
                        {isExpanded && kw.pages.length > 0 && kw.pages.map((pg, j) => (
                          <tr key={`${i}-${j}`} style={{ background: dark ? "#161622" : "#fafafa", borderBottom: `1px solid ${t.border}` }}>
                            <td colSpan={3} style={{ padding: "6px 10px 6px 30px", fontSize: 11, color: "#6366f1", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{pg.url}</td>
                            <td style={{ textAlign: "center" }}>{checkMark(pg.inTitle)}</td>
                            <td style={{ textAlign: "center" }}>{checkMark(pg.inDesc)}</td>
                            <td style={{ textAlign: "center" }}>{checkMark(pg.inH1)}</td>
                            <td style={{ textAlign: "center" }}>{checkMark(pg.inHeadings)}</td>
                            <td style={{ textAlign: "center" }}>{checkMark(pg.inText)}{pg.textCount > 0 && <span style={{ fontSize: 9, color: "#888", marginLeft: 2 }}>×{pg.textCount}</span>}</td>
                          </tr>
                        ))}
                        {isExpanded && kw.pages.length === 0 && (
                          <tr style={{ background: dark ? "#161622" : "#fafafa" }}>
                            <td colSpan={8} style={{ padding: "8px 30px", fontSize: 11, color: "#888" }}>Ключ не знайдено на жодній сторінці</td>
                          </tr>
                        )}
                      </Fragment>
                    );
                  })}
                </tbody>
              </table>
            </div>
          )}
          {filteredKeywords.length > visibleKw && (
            <button style={{ ...btnSm, width: "100%", marginTop: 8, padding: "8px 0" }} onClick={() => setVisibleKw(v => v + 100)}>
              Показати ще ({filteredKeywords.length - visibleKw} залишилось)
            </button>
          )}
        </div>
      )}
      {/* Tab: Extension Scans */}
      {tab === "extension" && (() => {
        const seoScore = (scan) => {
          let s = 100;
          const m = scan.meta || {};
          if (!m.title) s -= 25; else if ((m.title || "").length > 70 || (m.title || "").length < 30) s -= 10;
          if (!m.description) s -= 15; else if ((m.description || "").length > 160) s -= 5;
          if (scan.canonical_mismatch) s -= 20;
          const h1s = (scan.headings || []).filter(h => h.tag === "h1");
          if (h1s.length === 0) s -= 15; else if (h1s.length > 1) s -= 5;
          const cs = scan.content_stats || {};
          if ((cs.img_no_alt || 0) > 0) s -= 5;
          return Math.max(0, s);
        };
        const sortKey = extSort;
        const dir = extSortDir;
        const sorted = [...extScans].filter(s => !search || s.url.toLowerCase().includes(search.toLowerCase())).sort((a, b) => {
          if (sortKey === "seo") return (seoScore(a) - seoScore(b)) * dir;
          if (sortKey === "lcp") return (((a.speed || {}).lcp || 0) - ((b.speed || {}).lcp || 0)) * dir;
          if (sortKey === "cls") return (((a.speed || {}).cls || 0) - ((b.speed || {}).cls || 0)) * dir;
          if (sortKey === "words") return (((a.content_stats || {}).word_count || 0) - ((b.content_stats || {}).word_count || 0)) * dir;
          if (sortKey === "alerts") return ((a.alerts || []).length - (b.alerts || []).length) * dir;
          if (sortKey === "scanned_at") return (new Date(a.scanned_at) - new Date(b.scanned_at)) * dir;
          return 0;
        });
        const toggleSort = (key) => { if (extSort === key) setExtSortDir(d => d * -1); else { setExtSort(key); setExtSortDir(-1); } };
        const sHdr = (key, label) => (
          <th onClick={() => toggleSort(key)} style={{ textAlign: "center", padding: "8px 6px", fontWeight: 700, cursor: "pointer", userSelect: "none", whiteSpace: "nowrap" }}>
            {label} {extSort === key ? (extSortDir > 0 ? "↑" : "↓") : ""}
          </th>
        );
        const scColor = (v) => v >= 80 ? "#16a34a" : v >= 50 ? "#f59e0b" : "#ef4444";
        const lcpColor = (v) => v <= 2500 ? "#16a34a" : v <= 4000 ? "#f59e0b" : "#ef4444";
        const clsColor = (v) => v <= 0.1 ? "#16a34a" : v <= 0.25 ? "#f59e0b" : "#ef4444";

        return (
          <div style={{ overflowX: "auto" }}>
            {sorted.length === 0 ? (
              <p style={{ fontSize: 13, color: "#888", textAlign: "center", padding: 20 }}>
                Дані з розширення Chrome відсутні. Встановіть розширення Spalah SEO та відвідайте сторінки сайту.
              </p>
            ) : (
              <>
                <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 12 }}>
                  <thead>
                    <tr style={{ borderBottom: `2px solid ${t.border}` }}>
                      <th style={{ textAlign: "left", padding: "8px 10px", fontWeight: 700 }}>URL</th>
                      {sHdr("seo", "SEO")}
                      {sHdr("lcp", "LCP")}
                      {sHdr("cls", "CLS")}
                      {sHdr("words", "Слова")}
                      {sHdr("alerts", "Помилки")}
                      <th style={{ textAlign: "center", padding: "8px 6px", fontWeight: 700 }}>CMS</th>
                      <th style={{ textAlign: "center", padding: "8px 6px", fontWeight: 700 }}>CF</th>
                      {sHdr("scanned_at", "Дата")}
                    </tr>
                  </thead>
                  <tbody>
                    {sorted.slice(0, visibleExt).map((scan, i) => {
                      const sc = seoScore(scan);
                      const spd = scan.speed || {};
                      const cs = scan.content_stats || {};
                      const errs = (scan.alerts || []).filter(a => a.type === "error").length;
                      const warns = (scan.alerts || []).filter(a => a.type === "warning").length;
                      return (
                        <tr key={i} style={{ borderBottom: `1px solid ${t.border}` }}
                          onClick={() => setExpandedUrl(expandedUrl === scan.url ? null : scan.url)}
                        >
                          <td style={{ padding: "8px 10px", maxWidth: 280, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", cursor: "pointer" }}>
                            <span style={{ color: expandedUrl === scan.url ? "#6366f1" : "#888", fontSize: 10, marginRight: 6, display: "inline-block", transform: expandedUrl === scan.url ? "rotate(90deg)" : "none", transition: "transform .2s" }}>▶</span>
                            {new URL(scan.url).pathname || "/"}
                          </td>
                          <td style={{ textAlign: "center", fontWeight: 700, color: scColor(sc) }}>{sc}</td>
                          <td style={{ textAlign: "center", color: lcpColor(spd.lcp || 0) }}>{spd.lcp ? (spd.lcp / 1000).toFixed(1) + "s" : "—"}</td>
                          <td style={{ textAlign: "center", color: clsColor(spd.cls || 0) }}>{spd.cls != null ? spd.cls.toFixed(3) : "—"}</td>
                          <td style={{ textAlign: "center" }}>{cs.word_count || 0}</td>
                          <td style={{ textAlign: "center" }}>
                            {errs > 0 && <span style={{ color: "#ef4444", fontWeight: 600 }}>{errs}</span>}
                            {errs > 0 && warns > 0 && " / "}
                            {warns > 0 && <span style={{ color: "#f59e0b" }}>{warns}</span>}
                            {errs === 0 && warns === 0 && <span style={{ color: "#16a34a" }}>✓</span>}
                          </td>
                          <td style={{ textAlign: "center", fontSize: 10 }}>{scan.cms || "—"}</td>
                          <td style={{ textAlign: "center", fontSize: 10 }}>{scan.cloudflare ? "🟠" : "—"}</td>
                          <td style={{ textAlign: "center", fontSize: 10, color: t.textMuted }}>{scan.scanned_at ? new Date(scan.scanned_at).toLocaleDateString("uk") : ""}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
                {sorted.length > visibleExt && (
                  <button style={{ ...btnSm, width: "100%", marginTop: 8, padding: "8px 0" }} onClick={() => setVisibleExt(v => v + 50)}>
                    Показати ще ({sorted.length - visibleExt})
                  </button>
                )}
              </>
            )}
          </div>
        );
      })()}
    </div>
  );
};

// ═══ SEO COCOON VIEW — 3D Link Graph (sitemap.html style) ═══
